<div class="language-select__container">
  <div class="language-select__select-wrapper">
    <select
      class="language-select__select"
      [ngModel]="selectedLanguage"
      (ngModelChange)="onLanguageChange($event)"
    >
      <option *ngFor="let language of languages" [ngValue]="language">
        {{ language.label }}
      </option>
    </select>
  </div>
  <fa-icon class="language-select__icon" [icon]="['fas', 'globe']"></fa-icon>
  <a
    *ngIf="helpLink as url"
    class="language-select__help-link"
    [href]="url"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="'webPos.HelpLinkLabel' | translate"
    [title]="'webPos.HelpLinkLabel' | translate"
  >
    <fa-icon [icon]="helpIcon"></fa-icon>
  </a>
</div>
